import type { Session } from '@supabase/supabase-js';

// Session presence is not token validity: the SDK seeds `session` synchronously from
// localStorage and only nulls it after it observes expiry. Requiring an unexpired token
// keeps a focus/reconnect refetch from firing an org-scoped RPC as `anon` (→ 42501). The
// skew margin mirrors the SDK's own pre-expiry refresh - without it a token with under a
// tick of life left passes here and still expires before the RPC reaches Postgres.
const SESSION_EXPIRY_SKEW_MS = 10_000;
export function hasUnexpiredSession(session: Session | null | undefined): boolean {
  return session != null && (session.expires_at ?? 0) * 1000 - SESSION_EXPIRY_SKEW_MS > Date.now();
}
